// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"138":"96350fa5","408":"8b22a237","488":"d24ddc1f"}[chunkId] + ".chunk.js");